export { FullImage } from '@/components/common/HomepageHero/versions/FullImage';
export { SideBySide } from '@/components/common/HomepageHero/versions/SideBySide';
export { Offset } from '@/components/common/HomepageHero/versions/Offset';
export { Parallax } from '@/components/common/HomepageHero/versions/Parallax';
